import needs_work from 'Assets/icons/ratingNeedsWorkIcon.png';
import average from 'Assets/icons/ratingAverageIcon.png';
import good from 'Assets/icons/ratingGoodIcon.png';
import excellent from 'Assets/icons/ratingExcellentIcon.png';


export const ratingIcons = {
  needs_work,
  average,
  good,
  excellent
}